module.exports = __webpack_public_path__ + "static/media/webscape_24_runner_up.b6d12923.jpg";